import { useSessionAuth } from '@/context/Auth';
import { getNotifications } from '@/infrastructure/api/notifications';
import { UseQueryResult, useQuery } from '@tanstack/react-query';

export const useUnreadNotificationCount = (): UseQueryResult<
  { count: number },
  Error
> => {
  const { token } = useSessionAuth();

  return useQuery({
    queryKey: ['notifications', 'unread-count'],
    queryFn: async () => {
      const response = await getNotifications(token!, {
        params: {
          isRead: false,
          pageNo: 1,
          pageSize: 100, // Get enough notifications to count them
        },
      });

      // Count unread notifications from the data array since totalResults is not available
      const unreadCount = response.data?.filter(n => !n.isRead).length || 0;

      return { count: unreadCount };
    },
    refetchInterval: 30000, // Refetch every 30 seconds as fallback
    staleTime: 10000, // Consider data stale after 10 seconds
  });
};
